const CHANGE_FISCAL_INFO = 'paymentData/CHANGE_FISCAL_INFO';
const CHANGE_BILLING_CONTACT = 'paymentData/CHANGE_BILLING_CONTACT';
const SELECT_PAYMENT_METHOD = 'paymentData/SELECT_PAYMENT_METHOD';
const CHANGE_PAYMENT_TERM = 'paymentData/CHANGE_PAYMENT_TERM';

const submitPaymentData$ = 'paymentData/submitPaymentData$';
const changeToCreditCard$ = 'paymentData/changeToCreditCard$';

export default {
  CHANGE_FISCAL_INFO,
  CHANGE_BILLING_CONTACT,
  SELECT_PAYMENT_METHOD,
  CHANGE_PAYMENT_TERM,
  submitPaymentData$,
  changeToCreditCard$,
};
